module.exports = require('../_components/@alicd/next-moment/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/moment/index.js
// module id = 21
// module chunks = 0